module.exports = __webpack_public_path__ + "static/Circular-Std-Book-860c3ec7bbc5da3e97233ccecafe512e.ttf";